import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "./SurveyModal.css";


function SelectAndText ({title, options,lng,isEng,question,saveAnswer}){

  const { t } = useTranslation();
    const [selectedReasonsSingle, setSelectedReasonsSingle] = useState([]);
    const [chosenText, setChosenText] = useState('');

    const handleCheckboxChangeSingle = (reason) => {
    setSelectedReasonsSingle([reason]);
    console.log(chosenText,'chosenText')
  };
//To get the most recent selected option and text value
 useEffect(() => {
    if(selectedReasonsSingle.length > 0 && chosenText!==''){
        saveAnswer(question.QuestionID, 3, { selectedOption: selectedReasonsSingle, text: chosenText });
    }
    }, [ chosenText,selectedReasonsSingle]);

  const handleTextChange = (newValue, question) => {

    setChosenText(newValue);
  };

  const renderText=()=>{
    return(
        <div className="">
        <div className="survey_margin_top_and_bottom_page2 survey_common_style_center">
          <div className="survey_margin_bottom" style={{ textAlign: "center" }}>
          {t('Type your response')}
           <span style={{ color: "#D3D3D3" }}>({t("optional")})</span>
          </div>
  
          <textarea className="survey_text_area" style={lng === "arab" ? { direction: "rtl" } : null} placeholder={t('Type your response')} value={chosenText}
            onChange={(e)=>handleTextChange(e.target.value)}></textarea>
        </div>
  
      </div>
    )
  }
    return (
        <div className="survey_common_style_start_col">
          <div className="survey_margin_top_and_bottom_page2 survey_margin_left_and_right">
            <div style={lng === "arab" ? { direction: "rtl" } : null} className="survey_margin_bottom survey_align_center_text">
              {title ?? '-'}
              <span style={{ color: "#D3D3D3" }}>({t("optional")})</span>
            </div>
  
            {options?.map((reason, index) => {
              const optionLabel = isEng ? reason?.AnswerTitleE : reason?.AnswerTitleA;
              return (
                <label className="custom-checkbox" key={index}>
                  <input
                    type="checkbox"
                    checked={ selectedReasonsSingle.includes(reason)}
                    onChange={() => handleCheckboxChangeSingle(reason)}
                  />
                  <span className="checkmark"></span>
                  <span style={lng === "arab" ? { direction: "rtl" } : null}>{optionLabel ?? '-'}</span>
                </label>
              )
  
            })}
            {/* To show text field after any of the option is selected */}
            {selectedReasonsSingle?.length > 0 && (
                renderText()
              // renderText(isEng ? 'Type your response' : 'اكتب إجابتك', 'from_select_text')
            )}
          </div>
  
        </div>
      )
}

export default SelectAndText;